import { ActivityPhaseEnum } from '@src/model/activity/ActivityPhase';
import { IExamTemplate } from '@src/model/education/ExamTemplate';

export default class ExamTemplateHelperUtils {
  /** Check if exam template is in one of given statuses */
  static isExamTemplateInPhase = (examTemplate: IExamTemplate, requestedPhases: ActivityPhaseEnum[]): boolean => {
    return requestedPhases.some((phase) => examTemplate.activity.currentPhase.id === phase);
  };
}
